import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from '@portal/auth';

export function authInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const oidcSecurityService = inject(OidcSecurityService);
  const authService = inject(AuthService);

  return oidcSecurityService
    .getAccessToken()
    .pipe(switchMap(authToken => next(authService.addTokenHeader(request, authToken))));
}
